export default "__VITE_ASSET__e983541b__"